import styled from "styled-components";
import FlexBox from "./FlexBox";

const Wrapper = styled(FlexBox)`
  height: ${({ height }) => height || "100%"};
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

const Loader = ({
  wrapperHeight = "100%",
  backgroundColor = "transparent",
}) => {
  return (
    <Wrapper height={wrapperHeight} backgroundColor={backgroundColor}>
      <lottie-player
        src="https://assets.theinnerhour.com/compressed/Loader_TWA_Mobile_1769588288424_5sf8sis.json"
        background="transparent"
        speed="1"
        style={{ width: "80px", height: "80px" }}
        loop
        autoplay
      />
    </Wrapper>
  );
};

export default Loader;
